import React from "react";
import { Workflow, GraduationCap, BrainCircuit } from "lucide-react";

const items = [
    {
        Icon: Workflow,
        title: "Practical Learning Integrated With Academic Fundamentals",
    },
    {
        Icon: GraduationCap,
        title: "Industry-Aligned Curriculum Reflecting Current Practices",
    },
    {
        Icon: BrainCircuit,
        title: "Development Of Analytical Thinking And Decision-Making",
    },
];

export default function ProgramApproach() {
    return (
        <section
            data-testid="program-approach-section"
            className="relative py-20 sm:py-24 md:py-32 bg-white"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-10">
                <div className="flex items-end justify-between flex-wrap gap-6 mb-12 sm:mb-16 md:mb-20">
                    <div className="max-w-2xl">
                        <p
                            className="text-[11px] tracking-[0.22em] uppercase font-semibold mb-4"
                            style={{ color: "#2e326b" }}
                        >
                            Our Approach
                        </p>
                        <h2
                            className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight tracking-tight"
                            style={{ color: "#0f172a" }}
                        >
                            A Program Built For The
                            <br />
                            <span style={{ color: "#2e326b" }}>Real World</span>
                        </h2>
                    </div>
                    <div className="hidden md:block h-px flex-1 min-w-[120px] bg-slate-200 mb-4" />
                </div>

                {/* Stacked aligned list (3 rows) */}
                <div className="divide-y divide-slate-200 border-t border-b border-slate-200">
                    {items.map(({ Icon, title }, idx) => (
                        <div
                            key={idx}
                            data-testid={`approach-item-${idx}`}
                            className="group flex items-center gap-5 sm:gap-7 py-7 sm:py-9 md:py-10 transition-colors hover:bg-slate-50/60"
                        >
                            <span
                                className="hidden sm:inline-flex shrink-0 text-xs font-mono font-bold tracking-widest"
                                style={{ color: "#ffc004", minWidth: "32px" }}
                            >
                                {String(idx + 1).padStart(2, "0")}
                            </span>
                            <div
                                className="shrink-0 flex items-center justify-center h-12 w-12 sm:h-14 sm:w-14 rounded-xl transition-transform duration-300 group-hover:translate-y-[-2px]"
                                style={{ background: "rgba(255, 192, 4, 0.18)" }}
                            >
                                <Icon
                                    className="h-5 w-5 sm:h-6 sm:w-6"
                                    strokeWidth={1.6}
                                    style={{ color: "#2e326b" }}
                                />
                            </div>
                            <h3
                                className="text-base sm:text-lg md:text-xl font-normal leading-snug flex-1"
                                style={{ color: "#0f172a" }}
                            >
                                {title}
                            </h3>
                            <span
                                className="hidden md:inline-block h-px w-10 transition-all duration-500 group-hover:w-20 shrink-0"
                                style={{ background: "#ffc004" }}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
